import { FORM_PROVIDER_API_APPENDIX } from 'constants/baseUrl';
import { formProviderApi } from '.';

export const getForm = (formKey: string) => {
  return formProviderApi.get$(`${FORM_PROVIDER_API_APPENDIX}/${formKey}`);
};
